import React, { ComponentType } from 'react';
import { usePortalBoxHandler } from '@/features/shared/HOCs';
import {
  PORTAL_NAV_BOX_HEADER_EVENT,
  PORTAL_NAV_BOX_HEADER_ID,
} from '@/features/PortalNavigation/PortalNavigation.constants';
import { createPortal } from 'react-dom';

export const withStickyWrapper =
  <P extends object>(Component: ComponentType<P>) =>
  (props: P) => {
    const { elementPortalBox } = usePortalBoxHandler({
      boxId: PORTAL_NAV_BOX_HEADER_ID,
      readyEventName: PORTAL_NAV_BOX_HEADER_EVENT,
    });

    return (
      <>
        {elementPortalBox
          ? createPortal(<Component {...props} />, elementPortalBox, 'portalInline')
          : null}
      </>
    );
  };
